import { render, staticRenderFns } from "./en-CA.vue?vue&type=template&id=157794db&scoped=true&"
var script = {}
import style0 from "./en-CA.vue?vue&type=style&index=0&id=157794db&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157794db",
  null
  
)

export default component.exports